import axios from "axios";
import * as actionType from "../../../constant/actionType";
export const GetAllProviderListForReport =
  (apidata, Path) => async (dispatch) => {
    /*** API Call Action ***/
    try {
      const trimmedPath =
        typeof Path === "string" ? Path.replace(/^\/+|\/+$/g, "") : "";
      const normalizedPath =
        trimmedPath && trimmedPath !== "admin" ? `${trimmedPath}/` : "";
      const response = await axios({
        method: "get",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
        },
        url: `${actionType.environment_url}/api/admin/${normalizedPath}GetAllProviderListForReport`,
        params: apidata,
      });
      return response.data;
    } catch (error) {
      return error.message;
    }
  };
